import React from 'react'
import { Footer } from '../core/Footer'
import { Navbar } from '../core/Navbar'
import { TopNav } from '../core/TopNav'
import { Content } from '../sections/contact/Content'

export const Contact = () => {
    return (
        <div>
            <TopNav />
            <Navbar />
            <Content/>
            <Footer/>
        </div>
    )
}
